var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
var WriteOperation;
((WriteOperation2) => {
  class Operation {
  }
  WriteOperation2.Operation = Operation;
  class ContentfulOperation extends Operation {
  }
  WriteOperation2.ContentfulOperation = ContentfulOperation;
  class Update extends ContentfulOperation {
    constructor() {
      super(...arguments);
      __publicField(this, "op", "update");
    }
  }
  WriteOperation2.Update = Update;
  class Create extends ContentfulOperation {
    constructor() {
      super(...arguments);
      __publicField(this, "op", "create");
    }
  }
  WriteOperation2.Create = Create;
  class Delete extends Operation {
    constructor() {
      super(...arguments);
      __publicField(this, "op", "delete");
    }
  }
  WriteOperation2.Delete = Delete;
})(WriteOperation || (WriteOperation = {}));
export {
  WriteOperation
};
//# sourceMappingURL=types.js.map
